export default __webpack_public_path__ + "img/beneficios-bg-card-5.f4fe3d1c.png";